import { QUERY_KEY } from '@constants/queries';

import { useQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import {
  ApiListResponse,
  LivePostFilters,
  PublicLivePost,
} from '@utils/typesPages/types';

export const fetchLivePostsByBlog = async (params: LivePostFilters) => {
  const { data } = await GET<ApiListResponse<PublicLivePost[]>>(
    `/api/live-blogs/${params?.slug}/posts`,
    {
      params: params,
    }
  );

  return data;
};

export const useFetchLivePostsByBlog = (params: LivePostFilters) => {
  return useQuery({
    queryKey: [QUERY_KEY.FETCH_LIVE_POSTS, params],
    queryFn: () => fetchLivePostsByBlog(params),
    refetchInterval: 300000,
    gcTime: 300000,
    refetchOnWindowFocus: true,
  });
};
